module.exports = __webpack_public_path__ + "static/img/RP-F24V5_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RP-F24V5_1.png
// module id = rqv/
// module chunks = 0